export default "/_next/static/media/landing-hero-desk.db46b065d6b5a654037d7dccaa4cd8fd.webm";